import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ChartPie } from 'common/charts';
import { fetchCasesReports } from 'actions/Report/Case';
import _ from 'lodash';

export default class CasesByStatus extends Component {
  constructor(props) {
    super(props);
    this.fetchData = this.fetchData.bind(this);
    this.state = {
      casesByStatus: [],
      title: '',
    };
  }

  componentDidMount() {
    this.fetchData(this.props.filters);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.filters, nextProps.filters)) {
      this.fetchData(nextProps.filters);
    }
  }

  fetchData(filters) {
    const { scope, id } = this.props;
    fetchCasesReports(scope, id, 'by-status', filters)
      .then((response) => {
        this.setState({
          casesByStatus: _.orderBy(_.get(response, 'data.values', []), 'title', 'asc'),
          title: _.get(response, 'data.title', ''),
        });
        this.props.loaded('casesByStatus');
      });
  }

  render() {
    if (_.isEmpty(this.state.casesByStatus)) {
      return null;
    }
    return (
      <ChartPie
        data={this.state.casesByStatus}
        title={this.state.title}
        x={(d) => d.title}
        y={(d) => d.total}
        style={{ height: '350px' }}
        valueFormat="d"
        twoColsLegend={false}
        colors={[
          '#74B57D',
          '#4A657F',
          '#FF9900',
        ]}
      />
    );
  }
}

CasesByStatus.propTypes = {
  filters: PropTypes.shape({
    end_date: PropTypes.string,
    network_ids: PropTypes.array,
    start_date: PropTypes.string,
  }),
  loaded: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  scope: PropTypes.string.isRequired,
};
